// Mock data for H2 Element website clone

export const navItems = [
{ label: 'HOME', href: '#top' },
{ label: 'CATALOG', href: '#catalog' },
{ label: 'ABOUT PRODUCTION', href: '#production' },
{ label: 'DEALERS', href: '#dealers' },
{ label: 'CASES', href: '#cases' },
{ label: 'NEWS', href: '#news' },
{ label: 'CERTIFICATES', href: '#certificates' },
{ label: 'FAQ', href: '#faq' },
{ label: 'CONTACTS', href: '#contacts' }];


export const heroFeatures = [
{ icon: 'fuel', text: 'Fuel and resource savings' },
{ icon: 'wrench', text: 'Installation without affecting the warranty' },
{ icon: 'engine', text: 'For all internal combustion engines (ICE): commercial and passenger transport' }];


export const benefits = [
{
  title: 'Fuel savings 20–65%',
  description: 'Results are confirmed by measurements on your equipment. Payback — from 12 to 35 days',
  image: 'https://static3.tildacdn.com/tild6166-6232-4664-b137-336531346634/2_1.png'
},
{
  title: 'Engine runs smoother and longer',
  description: 'Less load, reduced wear, temperature stabilization from the first trips',
  image: 'https://static3.tildacdn.com/tild3534-3066-4264-b464-303232656238/2_2.png'
},
{
  title: 'No risks for warranty and engine',
  description: 'Installation according to official regulations, without complex modifications',
  image: 'https://static3.tildacdn.com/tild3061-6362-4164-b166-393539666330/2_3.png'
},
{
  title: 'Transparent, measurable results',
  description: 'Every step is confirmed by before/after measurement under engineer supervision',
  image: 'https://static3.tildacdn.com/tild6463-3835-4734-b966-306132666339/2_4.png'
}];


export const howItWorks = [
{ step: 1, title: 'Splits water into H2 and O2', description: 'Works parallel to standard components' },
{ step: 2, title: 'Mixes with air at intake', description: 'Does not require calibration' },
{ step: 3, title: 'Enriched mixture burns in cylinders', description: 'Does not interfere with vehicle electronics' },
{ step: 4, title: 'Better combustion efficiency', description: 'Fuel is used more efficiently' }];


export const products = [
{
  id: 'h1c',
  series: 'PRO MAX',
  model: 'H1',
  price: "$3499",
  engineVolume: 'Engine volume up to 6L',
  dimensions: '230×100×285 mm',
  warranty: '3 year warranty',
  image: '/equipment-pro-max-single.png',
  vehicleTypes: ['car']
},
{
  id: 'h2c',
  series: 'PRO MAX',
  model: 'H2',
  price: "$4499",
  engineVolume: 'Engine volume from 6 to 16L',
  dimensions: '265×100×285 mm',
  warranty: '3 year warranty',
  image: '/equipment-pro-max-double.png',
  vehicleTypes: ['car', 'truck']
}];


export const productionStats = [
{ icon: 'factory', title: 'Production capacity', description: 'Up to 1,500 H2 ELEMENT generators monthly, strict quality standards and control at every stage' },
{ icon: 'shield', title: 'Engineering oversight', description: 'Company experts and specialists from industry scientific clusters' },
{ icon: 'settings', title: 'Advanced equipment', description: 'Modern welding, painting and performance testing lines' },
{ icon: 'globe', title: 'Delivery geography', description: 'Worldwide exports through an extensive dealer network' },
{ icon: 'rocket', title: 'Own R&D department', description: 'Ensures updates and expansion of the product lineup' }];


export const caseStudies = [
// before/after = measured fuel use in L/100 km (used for savings %); UI shows US MPG.
{ car: 'Hyundai', before: '6.2', after: '3.5', unit: 'MPG (US)' },
{ car: 'TANK 300', before: '14.5', after: '10.2', unit: 'MPG (US)' },
{ car: 'Infiniti QX55 2011', before: '24', after: '13.6', unit: 'MPG (US)' },
{ car: 'ISUZU NQR 75', before: '18', after: '13.8', unit: 'MPG (US)' },
{ car: 'LEXUS LX 570', before: '17.3', after: '12.8', unit: 'MPG (US)' },
{ car: 'Geely Coolray', before: '9.5', after: '5.4', unit: 'MPG (US)' },
{ car: 'Nissan X-Trail 2.0 2011', before: '11.5', after: '8', unit: 'MPG (US)' },
{ car: 'Toyota Land Cruiser 200', before: '16.5', after: '11.2', unit: 'MPG (US)' }];


export const dealerBenefits = [
{ title: 'Exclusive', description: 'Your territory is assigned to you, without internal competition' },
{ title: 'Tools', description: 'Complete set for sales, marketing, analytics and workflow automation' },
{ title: 'Work Standards', description: 'Regulations for ads, promotions, communication management' },
{ title: 'Quick Support', description: 'Fast answers to all questions' },
{ title: 'Clear Terms', description: 'Transparent model, no hidden payments or forced purchases' },
{ title: 'Training', description: 'Access to H2 ELEMENT Academy — step-by-step onboarding program (60 days), materials, videos, curator support' }];


export const dealerSteps = [
{ step: '01', title: 'Fill out the application on the website', description: '' },
{ step: '02', title: 'Get a personal review', description: 'We discuss your region, target audience and marketing opportunities' },
{ step: '03', title: 'Access to the starter kit', description: 'Training, materials, dedicated manager' },
{ step: '04', title: 'Start sales and grow', description: 'Work with our system, receive support' }];


export const dealerPackage = [
{ icon: 'engine', title: 'Product', description: 'Assortment, use cases, limitations, answers to key questions' },
{ icon: 'chart', title: 'Goal Decomposition', description: 'Setting financial and operational KPIs, step-by-step growth plan' },
{ icon: 'headset', title: 'Sales', description: 'Call scripts, lead processing, CRM work, proposal templates' },
{ icon: 'package', title: 'Packaging', description: 'Profile standards, website design, social media, unified style' },
{ icon: 'mobile', title: 'Content', description: 'Content plan, instructions for posts, videos, cases and reviews' },
{ icon: 'people', title: 'Traffic', description: 'Launching ads, working with website and chatbot, lead funnel' },
{ icon: 'robot', title: 'AI Tools', description: 'Services and templates for quick material generation and lead processing' },
{ icon: 'settings2', title: 'Automation & Scaling', description: 'CRM implementation, process and metrics control, reporting templates' }];


export const newsItems = [
{
  title: 'H2 ELEMENT New Generation Generators',
  date: '23.12.2025',
  description: ''
},
{
  title: 'H2 ELEMENT Presentation Event',
  date: '14.12.2025',
  description: 'Full hall and live interest at the latest presentation event'
},
{
  title: 'Major Presentation of New Generation',
  date: '05.12.2025',
  description: 'Large-scale presentation of new generation H2 ELEMENT generators'
},
{
  title: 'Industry Conference',
  date: '19.11.2025',
  description: 'More than 200 attendees gathered'
},
{
  title: 'Fleet Managers Conference',
  date: '11.10.2025',
  description: 'Entrepreneurs and fleet owners learned about hydrogen technology'
},
{
  title: 'H2 Technology Introduction',
  date: '06.09.2025',
  description: 'Vehicle, logistics and agricultural equipment owners came to learn about saving fuel up to 65%'
}];


export const faqItems = [
{
  question: 'Is it safe for the engine?',
  answer: 'Yes. The generator does not interfere with the engine design and does not replace fuel — it simply improves combustion. Hydrogen breaks down carbon deposits, so there is less soot and abrasive elements in the engine. Hydrogen burns 8-10 times faster at lower temperatures, so the engine runs smoother and overheats less.'
},
{
  question: 'Is it legal? Do I need to register it?',
  answer: 'Absolutely legal. The HHO generator does not require registration because it is not a modification of the vehicle design. It works as an additional system and does not violate vehicle operation rules.'
},
{
  question: 'Which vehicles is it compatible with?',
  answer: 'Suitable for all types of internal combustion engines: gasoline, diesel, gas, methane (including LPG). Our installations are used by everyone — from passenger cars to trucks, tractors and special equipment. We select the model based on engine volume — efficiency is guaranteed.'
},
{
  question: 'How does it work?',
  answer: 'After starting the engine, the generator activates the electrolysis process, producing HHO gas (hydrogen-oxygen mixture, also called Brown\'s gas). This gas is fed into the combustion chamber along with air and fuel. HHO acts as a catalyst, accelerating and improving the combustion process of the fuel mixture.'
},
{
  question: 'What causes fuel savings?',
  answer: 'Savings are due to improved combustion characteristics of the fuel-air mixture by adding HHO. HHO has high flammability and low ignition temperature, which initiates more complete and uniform combustion. This leads to increased thermal efficiency, reduced soot formation, lower heat losses, and improved air-fuel ratio.'
},
{
  question: 'How difficult is the installation?',
  answer: 'Installation usually takes 60 to 90 minutes. Any auto electrician or mechanic can handle it — the instructions are step-by-step and simple. If something is unclear — our engineers are always available. We can help find an installer in your region.'
},
{
  question: 'Does the generator need maintenance?',
  answer: 'Maintenance is simple and does not require special knowledge. All you need is to add water and occasionally flush the system. Detailed maintenance and installation instructions are included with every kit.'
},
{
  question: 'Is there a warranty?',
  answer: 'Yes. We manufacture generators ourselves and provide a 3-year warranty. If something breaks down — we will replace it without any issues. Service life — up to 10 years.'
},
{
  question: 'How much does it cost?',
  answer: 'The price depends on the engine volume. Classic series: H1 up to 2L — $750, H2 from 2 to 6.5L — $990, H3 from 6.5 to 12L — $1,650. Smart series: H2 from 2 to 6.5L — $1,320, H3 from 6.5 to 12L — $1,980, H4 from 12 to 20L — $2,640.'
}];


export const teamMembers = [
  {
    name: 'Dmitrii Tolstikhin',
    roleKey: 'founder',
    image: 'https://customer-assets.emergentagent.com/job_h2-green-rebrand/artifacts/mfg2bfrj_me1.jpeg',
  },
  { name: 'Timothy Tolstikhin', roleKey: 'productManager' },
];